import React from 'react'
import { Typography, Button } from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

const No = (props) => {
	const history = useHistory()
	const dispatch = useDispatch()
	const params = useParams()
	const facility = useSelector((state) => state.specific.facilities.selected)
	const user = useSelector((state) => state.general.user.user)

	const roles = user?.roles || []
	const isGroomer = roles.length === 1 && roles.includes('Groomer')

	return (
		<div
			style={{
				display: 'flex',
				width: '100%',
				height: '100vh',
				justifyContent: 'center',
				alignItems: 'center'
			}}>
			<div
				style={{
					textAlign: 'center'
				}}>
				<Typography variant="h2" style={{ color: '#3B0275', fontSize: '22px', marginBottom: '40px' }}>
					You Do Not Have Access To This Page.
				</Typography>
				<Button
					variant="contained"
					onClick={() => {
						if (facility) {
							if (isGroomer) {
								history.push(`/facilities/${facility._id}/groomingHome`)
							} else {
								history.push(`/facilities/${facility._id}/schedule`)
							}
						} else {
							history.push('/')
						}
					}}
					color="secondary">
					Back To Home
				</Button>
			</div>
		</div>
	)
}

export default No
